const formatBytes = size => {
  if (size === 0) return '0 Bytes';

  const magnitude = Math.floor(Math.log(size) / Math.log(1024));

  return `${parseFloat((size / 1024 ** magnitude).toFixed(2))} ${['Bytes', 'KB', 'MB'][magnitude]}`;
};

export { formatBytes };
